module.exports = __webpack_public_path__ + "img/1-2.e6c0cc0d.jpg";